module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.venue.name))]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [_c('carousel', {
    staticStyle: {
      "text-shadow": "1px 1px 2px #333"
    },
    attrs: {
      "per-page": 1,
      "paginationPadding": 4,
      "paginationSize": 6
    }
  }, _vm._l((_vm.venue.pictures), function(picture) {
    return _c('slide', {
      key: picture.signature
    }, [_c('img', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "src": _vm.getThumb(picture.url)
      }
    })])
  }))], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "lg": "6"
    }
  }, [(_vm.venue.is_restaurant_ticket_friendly) ? _c('p', [_c('strong', [_vm._v("TR")]), _vm._v(" "), _c('sup', [_vm._v("friendly")])]) : _c('p', [_c('strong', [_vm._v("TR")]), _vm._v(" "), _c('sup', [_c('u', [_vm._v("NOT")]), _vm._v(" friendly")])]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.venue.description))]), _vm._v(" "), _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 16
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": _vm.center,
      "clickable": false,
      "draggable": false
    }
  })], 1), _vm._v(" "), (_vm.venue.address) ? _c('p', [_vm._v("\n        " + _vm._s(_vm.venue.address.street_number) + "\n        " + _vm._s(_vm.venue.address.route) + ",\n        " + _vm._s(_vm.venue.address.postal_code) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.venue.user) ? _c('p', [_c('strong', [_vm._v("Recommended by:")]), _vm._v(" "), _c('b-img', {
    attrs: {
      "src": _vm.venue.user.photoURL,
      "rounded": "circle",
      "width": "25px",
      "height": "25px"
    }
  }), _vm._v("\n        " + _vm._s(_vm.venue.user.displayName) + "\n      ")], 1) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "comments"
  }, [_c('vue-disqus', {
    attrs: {
      "shortname": "le11eme",
      "identifier": _vm.venue['.key']
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0426adbe","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Venue/Preview.vue
// module id = 655
// module chunks = 1